import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function NotFound() {
  const { t } = useTranslation('auth');
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <div className="text-center">
        <h1 className="text-display text-brand-900">404</h1>
        <p className="mt-2 text-body text-slate-600">{t('notFound.title')}</p>
        <Link
          to="/"
          className="mt-4 inline-block text-body text-accent-700 underline hover:text-accent"
        >
          {t('notFound.back')}
        </Link>
      </div>
    </div>
  );
}
